export const FETCH_WALLET = 'FETCH_WALLET';
export const FETCH_WALLET_SUCCESS = 'FETCH_WALLET_SUCCESS';
export const FETCH_WALLET_ERROR = 'FETCH_WALLET_ERROR';

export const FETCH_TRANSACTIONS = 'FETCH_TRANSACTIONS';
export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'FETCH_TRANSACTIONS_ERROR';

export const FETCH_WALLET_AND_TRANSACTIONS = 'FETCH_WALLET_AND_TRANSACTIONS';
export const FETCH_WALLET_AND_TRANSACTIONS_SUCCESS = 'FETCH_WALLET_AND_TRANSACTIONS_SUCCESS';
export const FETCH_WALLET_AND_TRANSACTIONS_ERROR = 'FETCH_WALLET_AND_TRANSACTIONS_ERROR';
